var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.4332C5.25197 3.4332 2.30648 5.21022 0.133016 8.09659C-0.0443388 8.33306 -0.0443388 8.66343 0.133016 8.8999C2.30648 11.7897 5.25197 13.5668 8.5 13.5668C11.748 13.5668 14.6935 11.7897 16.867 8.90338C17.0443 8.66691 17.0443 8.33654 16.867 8.10007C14.6935 5.21022 11.748 3.4332 8.5 3.4332ZM8.733 12.0679C6.57691 12.2036 4.79641 10.4265 4.93203 8.26699C5.04332 6.48648 6.4865 5.0433 8.267 4.93202C10.4231 4.7964 12.2036 6.57342 12.068 8.73298C11.9532 10.51 10.51 11.9532 8.733 12.0679ZM8.62519 10.4196C7.46369 10.4926 6.50389 9.53629 6.58039 8.37479C6.63951 7.41499 7.41848 6.6395 8.37829 6.5769C9.53979 6.50387 10.4996 7.4602 10.4231 8.6217C10.3605 9.58498 9.58152 10.3605 8.62519 10.4196Z",
    fill: "#0A46F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallEye);
export default __webpack_public_path__ + "static/media/SmallEye.b2bb9d3a.svg";
export { ForwardRef as ReactComponent };